import {processComponent} from "./utils"
( function() {
    'use strict';

    function rteLinkListener() {
        const textComponents = document.querySelectorAll( '.csh-aem-base-text' );

        textComponents.forEach( processComponent );
    }

    if ( document.readyState !== "loading" ) {
        rteLinkListener();
    } else {
        document.addEventListener( "DOMContentLoaded", rteLinkListener );
    }
}() );


